import {User} from "@irati/types"

interface ReduxType {
  type: string
}

export const AUTH_UPDATE: ReduxType = {type: "AuthActions_AuthUpdate"}
export const NO_AUTH_ACTION: ReduxType = {type: "AuthActions_LegacyNoAction"}

export interface SSOLoginInput {
  user: User
  access_token: string
}

export const SyncFromV4 = (auth: any | null) => {
  if (!auth) {
    return {
      type: AUTH_UPDATE,
      auth: null
    }
  }
  const {apps, user, sessionId, branding, userTenant, upsell, onboarding} = auth
  return {
    type: AUTH_UPDATE,
    auth: {
      apps,
      branding,
      featureFlags: {},
      onboarding,
      sessionId,
      upsell,
      user,
      userTenant
    }
  }
}

const NoAction = () => {
  return (dispatch: any) => {
    dispatch({
      type: NO_AUTH_ACTION
    })
    return Promise.resolve()
  }
}

const updateTenant = () => {
  return (dispatch: any, getState: () => any) => {
    dispatch({
      type: NO_AUTH_ACTION
    })
    return Promise.resolve(getState()?.auth?.userTenant)
  }
}

/** @deprecated: Do not use going forward, use `withAuth` or `useAuth` or auth helper */
export default {
  SyncFromV4,
  login: NoAction,
  resume: NoAction,
  ghostLogin: NoAction,
  singleSignOn: NoAction,
  logout: NoAction,
  updateTenant,
  UpdateAuthAction: NoAction,
  updateTenantFromRegionalIdentity: NoAction
}
